import React from "react";
import ContainerIn from "./pages/ContainerIn";

function Footer() {
  return (
    <ContainerIn>
      <div style={{padding:"30px",margin:"0 auto" }}>Meghedi Hacopi @ 2020</div>
    </ContainerIn>
  );
}

export default Footer;
